import { makeStyles, fade } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  formWrapper: {
    width: '100%',
    padding: theme.spacing(2, 0)
  },
  BasicInfoRow: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    '& label': {
      marginBottom: theme.spacing(1),
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.text.primary
    },
    '& .required': {
      color: theme.palette.error.main
    }
  },
  fileUploadWrapper: {
    position: 'relative',
    width: '100%',
    height: 40,
    boxShadow: `0px 0px 0px 1px ${fade(theme.palette.common.black, 0.1)}`,
    borderRadius: theme.spacing(0.75),

    '&:after': {
      content: 'attr(data-text)',
      fontSize: theme.typography.pxToRem(14),
      position: 'absolute',
      top: 0,
      left: 0,
      background: theme.palette.common.white,
      padding: theme.spacing(1.25, 2),
      display: 'block',
      width: 'calc(100% - 65px)',
      pointerEvents: 'none',
      zIndex: 20,
      height: 40,
      lineHeight: theme.typography.pxToRem(18),
      color: '#999',
      borderRadius: theme.spacing(0.625, 1.25, 1.25, 0.625),
      fontWeight: theme.typography.fontWeightRegular,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '&:before': {
      content: `${theme.direction === 'ltr' ? '\'Upload\'' : '\'إرفاق\''}`,
      position: 'absolute',
      top: 0,
      right: 0,
      display: 'inline-block',
      height: 40,
      transition: 'all 0.3s ease-in-out',
      border: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
      zIndex: 25,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(38),
      padding: theme.spacing(0, 3),
      textTransform: 'uppercase',
      pointerEvents: 'none',
      borderRadius: theme.spacing(0, 0.625, 0.625, 0)
    },

    '&:hover': {
      '&:before': {
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
      }
    }
  },
  fileUpload: {
    opacity: 0,
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 50,
    cursor: 'pointer'
  },
  templateTitle: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary
  },
  templateDownloadWrapper: {
    marginBottom: theme.spacing(3)
  },
  templateDownload: {
    padding: 0,
    textTransform: 'none',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightMedium,
    display: 'inline-flex',
    alignItems: 'center',
    gap: `${theme.spacing(1)}px`,
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      color: theme.palette.primary.dark
    }
  },
  FormSubmitRow: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    justifyContent: 'flex-end',
    '& .MuiButton-root': {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.pxToRem(18),
      padding: `${theme.spacing(1)}px ${theme.spacing(5)}px`
    }
  }
}))

